export default "__VITE_ASSET__DLIeOe0F__"